import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Box, Stack, Typography } from '@mui/material';

import { EditButtonGroup } from '../../../components/general';
import { capabilities, type Veranstaltung } from '../../../dtos';
import { formatTimeRangeForDate } from '../../../utils';
import { dayNumber } from './ablaufUtils';

type TerminAblaufCardProps = {
  readonly veranstaltung: Veranstaltung;
  readonly enableEditMode: (isEditMode: boolean) => void;
};

export const TerminAblaufViewCard = ({ veranstaltung, enableEditMode }: TerminAblaufCardProps) => {
  const ablauf = veranstaltung.ablauf;

  const canEditAblauf = veranstaltung.capabilities.includes(capabilities.EDIT_ABLAUF);
  const firstDay = ablauf[0].start;

  return (
    <Stack>
      {canEditAblauf && (
        <Box display="flex">
          <EditButtonGroup isEditMode={false} setEditMode={enableEditMode} />
        </Box>
      )}
      <Timeline
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.1,
          },
        }}
      >
        {ablauf.map((range, idx) => (
          <TimelineItem key={range.start.getTime()}>
            <TimelineOppositeContent align="right" whiteSpace="nowrap">
              {dayNumber(firstDay, range.start)}. Tag
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              {idx + 1 < ablauf.length ? <TimelineConnector /> : null}
            </TimelineSeparator>
            <TimelineContent>
              <Typography>{formatTimeRangeForDate(range.start, range.end)}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Stack>
  );
};
